import actions from 'actions'
import moment from 'moment'
import { Dispatch } from 'redux'

import { actionTypes } from 'actions/actionTypes'
import { menuLoadStock } from 'actions/menu'
import { loadRecipeAvailability } from 'actions/recipeAvailability'
import { isOptimizelyFeatureEnabledFactory } from 'containers/OptimizelyRollouts'
import fetchData from 'routes/Menu/fetchData'

import { AddRecipeFn } from '../domains/basket'
import { GetState, Query } from './types'

export const ensureCurrentMenuCoversDate =
  (
    date: string,
    { query, params, addRecipe }: { query?: Query; params?: any; addRecipe: AddRecipeFn },
  ) =>
  async (dispatch: Dispatch<any>, getState: GetState) => {
    const currentMenuEndsAt = (getState().menuService?.data || [])[0]?.attributes?.ends_at
    const currentMenuStartsAt = (getState().menuService?.data || [])[0]?.attributes?.starts_at

    const noCurrentMenuAvailable = !currentMenuEndsAt || !currentMenuStartsAt
    const dateIsOutsideCurrentMenu =
      moment(date) > moment(currentMenuEndsAt) || moment(date) < moment(currentMenuStartsAt)
    const isAdminQuery = query && query['preview[auth_user_id]']

    const needsToRefetchMenu = noCurrentMenuAvailable || dateIsOutsideCurrentMenu || !!isAdminQuery
    const isMenuApiStockEnabled = await isOptimizelyFeatureEnabledFactory(
      'turnips_web_menu_api_stock_enabled',
    )(dispatch, getState)

    if (needsToRefetchMenu) {
      await dispatch(
        fetchData({ query: query || {}, params: params || {} }, true, undefined, {
          addRecipe,
          date,
        }),
      )
    } else {
      dispatch(actions.pending(actionTypes.MENU_FETCH_DATA, true))
      if (!isMenuApiStockEnabled) {
        await dispatch(loadRecipeAvailability())
      }
      await dispatch(menuLoadStock())
      dispatch(actions.pending(actionTypes.MENU_FETCH_DATA, false))
    }
  }
